import React from 'react';
import Checkbox from '@amzn/meridian/checkbox';

export interface SessionMergeSelection {
  label: string;
  checked: boolean;
  disabled: boolean;
  onChange: () => void;
}

/** A session card's merge checkbox. */
const SessionMergeSelectionComponent: React.FC<SessionMergeSelection> = ({
  label,
  checked,
  disabled,
  onChange,
}) => (
  // The card itself is clickable, so keep checkbox clicks from also reaching it.
  <div onClick={(event) => event.stopPropagation()} style={{ marginBottom: '8px' }}>
    <Checkbox checked={checked} disabled={disabled} onChange={onChange}>
      {label}
    </Checkbox>
  </div>
);

export default SessionMergeSelectionComponent;
